import React from 'react';
import PropTypes from 'prop-types';

import FontIcon from './FontIcon';

import './styles/Banner.css';

const Banner = ({ message, dismissLabel, onDismiss = () => {} }) => (
  <div className="banner" role="region" aria-labelledby="bannerMessage">
    <span id="bannerMessage" className="message">
      {message}
    </span>
    <button
      type="button"
      className="dismissButton"
      aria-label={dismissLabel}
      onClick={(event) => {
        event.preventDefault();
        onDismiss();
      }}
    >
      <FontIcon icon="close" />
    </button>
  </div>
);

Banner.propTypes = {
  message: PropTypes.string.isRequired,
  dismissLabel: PropTypes.string.isRequired,
  onDismiss: PropTypes.func,
};

export default Banner;
